import { Environment } from '@embrace-it/planning-portal-library';

export const environment: Environment = {
  url: 'https://app-cubivuesaasmicroservicesplanningportalservice-test-001.azurewebsites.net',
  masterLocationUrl:
    'https://app-cubivuesaasmicroservicesmasterlocationservice-test-001.azurewebsites.net',
  mapServiceUrl: 'https://app-mapserviceapi-test-001.azurewebsites.net',
  amsURL: 'https://app-cubivuesaasmicroservicesareamanagement-test-001.azurewebsites.net',
  platformUrl:'https://apim-cubivueinfra-test-001.azure-api.net/platform',
  tolgee: {
    // cdnUrl: 'https://sttranslationsprod001.blob.core.windows.net/public/a5c5c4412b47dccbb71fd1f25695bd67',
    apiKey: 'tgpak_g5pwemdtnbrxgyteojuxi3dggjxgiobwnrzxioljgm4de',
    apiURL:
      'https://ca-tms.happymeadow-d5db8391.westeurope.azurecontainerapps.io',
  },
};
